import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {LocationFilter} from "./location.filter";
import { debounceTime } from 'rxjs/operators';
import {SettingsPersistenceService} from "../../services/settings-persistence.service";

@Component({
  selector: 'micro-locations',
  templateUrl: './locations.component.html'
})
export class LocationsComponent implements OnInit, OnDestroy  {

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:LocationFilter = new LocationFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  pageSettings:SettingsPersistenceService;

  constructor(protected auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.locations");
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)                 // page paginator object
      .init();

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      ;

    this.http.get(`${this.env.e.url}/domain/locations`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
